export function StatusPill({ status, pending = 0, conflicts = 0 }) {
  const cls = conflicts
    ? 'error'
    : status === 'error'
      ? 'error'
      : status === 'offline'
        ? 'offline'
        : pending
          ? 'warn'
          : 'online';
  const label = conflicts
    ? `${conflicts} conflict`
    : status === 'offline'
      ? pending
        ? `offline · ${pending}`
        : 'offline'
      : pending
        ? `${pending} pending`
        : 'synced';
  return (
    <span class={`pill ${cls}`}>
      <span class="dot" />
      {label}
    </span>
  );
}
